import { render, staticRenderFns } from "./newManager.vue?vue&type=template&id=76dd35cc&scoped=true&"
import script from "./newManager.vue?vue&type=script&lang=js&"
export * from "./newManager.vue?vue&type=script&lang=js&"
import style0 from "./newManager.vue?vue&type=style&index=0&id=76dd35cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dd35cc",
  null
  
)

export default component.exports